import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Statistic, Spin } from 'antd'
import { UserOutlined, ShoppingCartOutlined, DollarOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { getStats, AdminStats } from '../../api/admin'

const Dashboard: React.FC = () => {
  const navigate = useNavigate()
  const [stats, setStats] = useState<AdminStats | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadStats()
  }, [])

  const loadStats = async () => {
    try {
      const data = await getStats()
      setStats(data)
    } catch {
      // 错误已在拦截器中处理
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 50 }}>
        <Spin size="large" />
      </div>
    )
  }

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>📊 仪表盘</h2>

      <Row gutter={16}>
        <Col span={8}>
          <Card>
            <Statistic
              title="总用户数"
              value={stats?.total_users || 0}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="总订单数"
              value={stats?.total_orders || 0}
              prefix={<ShoppingCartOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="流通审批币"
              value={stats?.total_coins_in_circulation || 0}
              prefix={<DollarOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
      </Row>

      <Card title="快捷操作" style={{ marginTop: 24 }}>
        <Row gutter={16}>
          <Col span={6}>
            <Card hoverable onClick={() => navigate('/users')}>
              👥 用户管理
            </Card>
          </Col>
          <Col span={6}>
            <Card hoverable onClick={() => navigate('/orders')}>
              📦 订单管理
            </Card>
          </Col>
          <Col span={6}>
            <Card hoverable onClick={() => navigate('/ledger')}>
              📒 账本管理
            </Card>
          </Col>
          <Col span={6}>
            <Card hoverable onClick={() => navigate('/configs')}>
              ⚙️ 系统配置
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  )
}

export default Dashboard
